import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
export function Hero() {
  const scrollToCompra = () => {
    const element = document.querySelector('#compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-[100dvh] px-4 py-4 md:pt-32 md:pb-24 overflow-hidden bg-darker flex items-center" data-id="element-63">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(34,197,94,0.05)_0%,transparent_70%)] pointer-events-none" data-id="element-64"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10 flex flex-col justify-between gap-3 md:gap-6 w-full" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-66">
          <h1 className="text-3xl md:text-7xl font-bold text-gray-900 mb-1 md:mb-6 leading-tight" data-id="element-67">
            SISTEMA MEGAKIT: <br data-id="element-68" />
            <span className="text-gold" data-id="element-69">ADN CAPILAR PRO</span>
          </h1>

          <p className="text-sm md:text-2xl text-gray-600 mb-2 md:mb-12 max-w-3xl mx-auto font-medium leading-snug md:leading-relaxed" data-id="element-70">
            El Protocolo de Ingeniería Capilar Natural para el Pibe Argentino
            que no se Resigna a Quedarse Pelado
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="cursor-pointer" onClick={scrollToCompra} data-id="element-71">
          <img src="https://cdn.magicpatterns.com/uploads/vrRJbMFVHCmb1YGMcNd6UX/capilar_adn-removebg-preview.png" alt="Sistema Megakit ADN Capilar Pro" className="w-full max-w-[220px] md:max-w-lg mx-auto rounded-lg shadow-[0_0_40px_rgba(34,197,94,0.15)]" data-id="element-72" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="max-w-2xl mx-auto w-full" data-id="element-73">
          <div className="bg-white/80 border border-gray-200 rounded-lg p-3 md:p-6 backdrop-blur-sm shadow-sm" data-id="element-74">
            <p className="text-gold font-heading font-bold text-xs md:text-lg mb-2 md:mb-4 uppercase tracking-wide" data-id="element-75">
              ¿Qué incluye el Sistema Megakit?
            </p>
            <div className="grid grid-cols-2 gap-x-3 gap-y-2 text-left text-[11px] md:text-base" data-id="element-76">
              <div className="flex items-start gap-1.5 text-gray-600" data-id="element-77">
                <span className="text-green-500 shrink-0" data-id="element-78">✅</span>
                <span data-id="element-79">
                  <strong className="text-gray-900" data-id="element-80">6 Tomos</strong> — Limpieza,
                  Tónicos, Anti-DHT, Irrigación, Nutrición y Mantenimiento
                </span>
              </div>
              <div className="flex items-start gap-1.5 text-gray-600" data-id="element-81">
                <span className="text-green-500 shrink-0" data-id="element-82">✅</span>
                <span data-id="element-83">
                  <strong className="text-gray-900" data-id="element-84">5 Bonos GRATIS</strong> —
                  Guías de compra, etiquetas, tracker, alergias y rutinas
                  express
                </span>
              </div>
              <div className="flex items-start gap-1.5 text-gray-600" data-id="element-85">
                <span className="text-green-500 shrink-0" data-id="element-86">✅</span>
                <span data-id="element-87">
                  <strong className="text-gray-900" data-id="element-88">+15 recetas</strong> de
                  tónicos y preparados naturales
                </span>
              </div>
              <div className="flex items-start gap-1.5 text-gray-600" data-id="element-89">
                <span className="text-green-500 shrink-0" data-id="element-90">✅</span>
                <span data-id="element-91">
                  <strong className="text-gray-900" data-id="element-92">Protocolo 90 días</strong> —
                  20 min/día, sin químicos
                </span>
              </div>
            </div>
            <p className="text-gray-500 text-[10px] md:text-xs mt-2 md:mt-4 text-center" data-id="element-93">
              Acceso inmediato · Digital · Ingredientes 100% naturales de
              Argentina
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-94">
          <CTAButton className="w-full md:w-auto text-base md:text-2xl py-3 md:py-4" data-id="element-95">
            QUIERO RECUPERAR MI PELO AHORA
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}